<section class="ecb-x-admin-list-section">

  <div class="container-fluid">

    <div class="ecb-x-admin-list-card">
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
        <div>
          <h1 class="ecb-section-title">Orders</h1>
          <p class="ecb-muted mb-0">View purchases, payment statuses, order details and invoices.</p>
        </div>
      </div>

      <p-table [value]="pagedOrders" responsiveLayout="scroll" styleClass="ecb-admin-table">

        <!-- Header -->
        <ng-template pTemplate="header">

          <tr class="ecb-admin-table-header-row">

            <th class="ecb-admin-table-header">
              Order No
            </th>

            <th class="ecb-admin-table-header">
              Customer
            </th>

            <th class="ecb-admin-table-header">
              Email
            </th>

            <th class="ecb-admin-table-header">
              Total
            </th>

            <th class="ecb-admin-table-header">
              Status
            </th>

            <th class="ecb-admin-table-header">
              Created
            </th>

            <th class="ecb-admin-table-header ecb-admin-table-action-header">
              Actions
            </th>

          </tr>

        </ng-template>


        <!-- Body -->
        <ng-template pTemplate="body" let-row>

          <tr class="ecb-admin-table-row">

            <!-- Order No -->
            <td class="ecb-admin-table-cell">

              <strong>
                {{ row.orderNo }}
              </strong>

            </td>


            <!-- Customer -->
            <td class="ecb-admin-table-cell">

              {{ row.customerName || '-' }}

            </td>


            <!-- Email -->
            <td class="ecb-admin-table-cell">

              {{ row.customerEmail || '-' }}

            </td>


            <!-- Total -->
            <td class="ecb-admin-table-cell">

              {{ row.currencyCode || 'AUD' }}
              {{ row.totalAmount | number:'1.2-2' }}

            </td>


            <!-- Status -->
            <td class="ecb-admin-table-cell">



              <span  class="ecb-admin-order-status" [class.ecb-admin-order-status-paid]="row.paymentStatus === 'Paid'"
                [class.ecb-admin-order-status-pending]="row.paymentStatus !== 'Paid'">

                {{ row.paymentStatus || 'Pending' }}

              </span>

            </td>


            <!-- Created -->
            <td class="ecb-admin-table-cell">

              {{ row.createdDate | date:'mediumDate' }}

            </td>


            <!-- Actions -->
           <td class="ecb-admin-table-cell ecb-admin-table-action-cell">


              <!-- View -->
              <button type="button" class="ecb-admin-table-action-button ecb-admin-table-view-button"
                (click)="viewOrderDetails(row)" title="View order">

              
                <i class="bi bi-eye ecb-admin-table-action-icon">
                </i>

              </button>


              <!-- Invoice -->
              <button type="button" class="ecb-admin-table-action-button ecb-admin-table-download-button"
                (click)="downloadInvoice(row)" title="Download invoice">

                <i class="fa fa-download ecb-admin-table-action-icon" aria-hidden="true">
                </i>

              </button>

            </td>

          </tr>

        </ng-template>


        <!-- Empty -->
        <ng-template pTemplate="emptymessage">

          <tr class="ecb-admin-table-row">

            <td colspan="7" class="ecb-admin-table-cell text-center py-4">

              No orders found.

            </td>

          </tr>

        </ng-template>

      </p-table>


      <!-- Start Orders Table Footer -->
      <div class="ecb-x-admin-orders-table-footer">

        <div class="row align-items-center gy-3">

          <!-- Showing Records -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-orders-paginator-info">

              Showing
              {{ startRecord }}–{{ endRecord }}
              of {{ rows.length }} orders

            </div>

          </div>


          <!-- Rows Per Page -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-orders-paginator-size">

              <label>
                Rows per page
              </label>

              <select class="form-select form-select-sm" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">

                <option [ngValue]="10">10</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>

              </select>

            </div>

          </div>


          <!-- Page Navigation -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-orders-paginator-navigation">

              <!-- Previous -->
              <button type="button" class="ecb-x-admin-orders-page-button" [disabled]="currentPage === 1"
                (click)="previousPage()">

                Previous

              </button>


              <!-- Page Numbers -->
              <button type="button" *ngFor="let page of pageNumbers" class="ecb-x-admin-orders-page-button"
                [class.ecb-x-admin-orders-page-active]="currentPage === page"
                [attr.aria-current]="currentPage === page ? 'page' : null" (click)="changePage(page)">

                {{ page }}

              </button>


              <!-- Next -->
              <button type="button" class="ecb-x-admin-orders-page-button" [disabled]="currentPage === totalPages"
                (click)="nextPage()">

                Next

              </button>

            </div>

          </div>

        </div>

      </div>
      <!-- End Orders Table Footer -->

    </div>
  </div>
</section>

<p-dialog [(visible)]="showOrderDetails" [modal]="true" [style]="{width:'820px'}" header="Order Details"
  styleClass="ecb-order-dialog">
  <div *ngIf="selectedOrder" class="order-detail-box">
    <div class="order-detail-header">
      <div>
        <span class="detail-label">Order No</span>
        <h3>{{ selectedOrder.orderNo }}</h3>
      </div>
      <p-tag [value]="selectedOrder.paymentStatus"
        [severity]="selectedOrder.paymentStatus === 'Paid' ? 'success' : 'warning'"></p-tag>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-md-6">
        <div class="detail-card">
          <h4>Customer Details</h4>
          <p *ngIf="selectedOrder.customerName"><strong>Name:</strong> {{ selectedOrder.customerName }}</p>
          <p *ngIf="selectedOrder.customerEmail"><strong>Email:</strong> {{ selectedOrder.customerEmail }}</p>
          <p *ngIf="selectedOrder.customerMobileNo"><strong>Phone:</strong> {{ selectedOrder.customerMobileNo }}</p>
        </div>
      </div>
      <div class="col-md-6"
        *ngIf="selectedOrder.dateRange || selectedOrder.time || selectedOrder.locationName || selectedOrder.deliveryMode">
        <div class="detail-card">
          <h4>Training Details</h4>
          <p *ngIf="selectedOrder.dateRange"><strong>Date:</strong> {{ selectedOrder.dateRange }}</p>
          <p *ngIf="selectedOrder.time"><strong>Time:</strong> {{ selectedOrder.time }}</p>
          <p *ngIf="selectedOrder.locationName"><strong>Location:</strong> {{ selectedOrder.locationName }}</p>
          <p *ngIf="selectedOrder.deliveryMode"><strong>Delivery:</strong> {{ selectedOrder.deliveryMode }}</p>
        </div>
      </div>
    </div>

    <div class="detail-card mb-3">
      <h4>Purchased Courses</h4>
      <div class="order-item-row" *ngFor="let item of getOrderItems(selectedOrder)">
        <div>
          <strong>{{ item.courseName }}</strong><span *ngIf="item.courseType" class="badge bg-light text-primary ms-2">{{ item.courseType === 'SHORT' ? 'Short Course' : 'Qualification' }}</span>
          <span *ngIf="item.dateRange || item.locationName">{{ item.dateRange }} {{ item.locationName ? ' • ' +
            item.locationName : '' }}</span>
        </div>
        <b>{{ selectedOrder.currencyCode || 'AUD' }} {{ item.lineAmount | number:'1.2-2' }}</b>
      </div>
    </div>

    <div class="total-panel">
      <span>Total Amount</span>
      <strong>{{ selectedOrder.currencyCode || 'AUD' }} {{ selectedOrder.totalAmount | number:'1.2-2' }}</strong>
    </div>

    <div class="text-end mt-3">
      <button class="ecb-btn-primary" type="button" (click)="downloadInvoice(selectedOrder)"><i
          class="fa fa-download"></i> Download Invoice</button>
    </div>
  </div>
</p-dialog>